<svg version="1.1" id="body_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" xml:space="preserve"  height="715px" width="1100px" >
<image href="./assets/images/photos/CarInterior.png" height="715px" width="1100px" />

<!-- side mirrors -->
<rect x="20" y="244" height="75" width="118" style="fill:transparent; stroke-width:2;cursor: pointer;" [attr.stroke]="sideMirrors" (click)="clickImageArea('Side Mirrors')"/>
<rect x="948" y="244" height="75" width="118" style="fill:transparent; stroke-width:2;cursor: pointer;" [attr.stroke]="sideMirrors" (click)="clickImageArea('Side Mirrors')"/>

<!-- steering wheel -->
<circle cx="740" cy="380" r="144" stroke-width="2" fill="transparent" style="cursor: pointer;" [attr.stroke]="steeringWheel" (click)="clickImageArea('Steering Wheel')"/>

<!-- gear leaver -->
<rect x="502" y="554" height="110" width="70" style="fill:transparent; stroke-width:2;cursor: pointer;" [attr.stroke]="gearLever" (click)="clickImageArea('Gear Leaver')"/>

<!-- turn signal indicator -->
<rect x="890" y="331" height="30" width="50" style="fill:transparent; stroke-width:2;cursor: pointer;" [attr.stroke]="turnSignalLeaver" (click)="clickImageArea('Turn Signal Indicator')"/>

<!-- wiper  -->
<rect x="532" y="330" height="30" width="55" style="fill:transparent; stroke-width:2;cursor: pointer;" [attr.stroke]="wiperLeaver" (click)="clickImageArea('Wiper Leaver')"/>

<!-- pedals -->
<rect x="671" y="524" height="30" width="30" style="fill:transparent; stroke-width:2;cursor: pointer;" [attr.stroke]="clutch" (click)="clickImageArea('Clutch')"/>
<rect x="738" y="524" height="30" width="30" style="fill:transparent; stroke-width:2;cursor: pointer;" [attr.stroke]="break" (click)="clickImageArea('Break')"/>
<rect x="776" y="524" height="30" width="30" style="fill:transparent; stroke-width:2;cursor: pointer;" [attr.stroke]="petrol" (click)="clickImageArea('Petrol')"/>

<!-- Rear mirror -->
<rect x="415" y="76" height="84" width="260" style="fill:transparent; stroke-width:2;cursor: pointer;" [attr.stroke]="rearMirror" (click)="clickImageArea('Rear Mirror')"/>

<!-- emergency flashers -->
<rect x="520" y="410" height="30" width="30" style="fill:transparent; stroke-width:2;cursor: pointer;" [attr.stroke]="emergencyFlasher" (click)="clickImageArea('Emergency Flasher')"/>

<!-- hand break -->
<rect x="503" y="527" height="30" width="70" style="fill:transparent; stroke-width:2;cursor: pointer;" [attr.stroke]="handbreak" (click)="clickImageArea('Hand Break')"/>

<!-- windscreen wipers -->
<rect x="267" y="240" height="50" width="350" style="fill:transparent; stroke-width:2;cursor: pointer;" [attr.stroke]="windscreenWipers" (click)="clickImageArea('Windscreen Wipers')"/>

<!-- hooter -->
<circle cx="736" cy="389" r="29" stroke-width="2" fill="transparent" style="cursor: pointer;" [attr.stroke]="hooter" (click)="clickImageArea('Hooter')"/>

<!-- screen -->
<rect x="480" y="448" height="50" width="110" style="fill:transparent; stroke-width:2;cursor: pointer;" [attr.stroke]="screen" (click)="clickImageArea('Screen')"/>

<!-- door handles -->
<!-- <rect x="89" y="379" height="60" width="60" style="fill:transparent; stroke-width:2;cursor: pointer;" [attr.stroke]="leftDoorHandle" (click)="clickImageArea('Left Door Handle')"/> -->
<rect x="930" y="379" height="60" width="60" style="fill:transparent; stroke-width:2;cursor: pointer;" [attr.stroke]="rightDoorHandle" (click)="clickImageArea('Right Door Handle')"/>

<!-- vents -->
<rect x="463" y="355" height="50" width="130" style="fill:transparent; stroke-width:2;cursor: pointer;" [attr.stroke]="middleVent" (click)="clickImageArea('Middle Vent')"/>
<rect x="194" y="368" height="40" width="75" style="fill:transparent; stroke-width:2;cursor: pointer;" [attr.stroke]="sideVents" (click)="clickImageArea('Side Vent')"/>
<rect x="212" y="317" height="40" width="40" style="fill:transparent; stroke-width:2;cursor: pointer;" [attr.stroke]="topVent" (click)="clickImageArea('Top Vent')"/>

<!-- glove box -->
<rect x="191" y="413" height="45" width="220" style="fill:transparent; stroke-width:2;cursor: pointer;" [attr.stroke]="gloveBox" (click)="clickImageArea('Glove Box')"/>

<!-- dashboard -->
<rect x="250" y="284" height="45" width="340" style="fill:transparent; stroke-width:2;cursor: pointer;" [attr.stroke]="dashboard" (click)="clickImageArea('Dashboard')"/>

<!-- speedometer  -->
<polygon points="681,317,741,304,818,327,818,345,668,343" style="fill:transparent;stroke-width:2;cursor: pointer;" [attr.stroke]="speedometer" (click)="clickImageArea('Speedometer')"/>


</svg>